import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 9.83333333,
  r: 1.33333333
});

var SvgBitbucket = function SvgBitbucket(props) {
  return _ref;
};

export default SvgBitbucket;